import { render, staticRenderFns } from "./Subscriber.vue?vue&type=template&id=3b7387b9&scoped=true&"
var script = {}
import style0 from "./Subscriber.vue?vue&type=style&index=0&id=3b7387b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7387b9",
  null
  
)

export default component.exports